// Generated by purs version 0.13.8
"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Lunarbox_Component_Icon = require("../Lunarbox.Component.Icon/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Data_Dataflow_Expression_Lint = require("../Lunarbox.Data.Dataflow.Expression.Lint/index.js");
var Lunarbox_Data_Dataflow_TypeError = require("../Lunarbox.Data.Dataflow.TypeError/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Lunarbox_Data_Editor_Location = require("../Lunarbox.Data.Editor.Location/index.js");
var Lunarbox_Data_Editor_Node_NodeId = require("../Lunarbox.Data.Editor.Node.NodeId/index.js");
var Lunarbox_Data_Editor_Node_PinLocation = require("../Lunarbox.Data.Editor.Node.PinLocation/index.js");
var Warning = (function () {
    function Warning() {

    };
    Warning.value = new Warning();
    return Warning;
})();
var $$Error = (function () {
    function $$Error() {

    };
    $$Error.value = new $$Error();
    return $$Error;
})();
var warningIcon = Lunarbox_Component_Icon.icon("warning");
var shouldRender = function (isInternal) {
    return function (v) {
        if (v instanceof Lunarbox_Data_Editor_Location.UnknownLocation) {
            return false;
        };
        if (v instanceof Lunarbox_Data_Editor_Location.AtFunction) {
            return !isInternal(v.value0);
        };
        if (v instanceof Lunarbox_Data_Editor_Location.InsideFunction) {
            return !isInternal(v.value0);
        };
        if (v instanceof Lunarbox_Data_Editor_Location.AtFunctionDeclaration) {
            return !isInternal(v.value0);
        };
        if (v instanceof Lunarbox_Data_Editor_Location.FixpointOperator) {
            return !isInternal(v.value0);
        };
        throw new Error("Failed pattern match at Lunarbox.Component.Editor.Problems (line 66, column 27 - line 71, column 51): " + [ v.constructor.name ]);
    };
};
var locationLEF = function (v) {
    if (v instanceof Lunarbox_Data_Editor_Location.UnknownLocation) {
        return {
            nth: Data_Maybe.Nothing.value,
            who: "unknown",
            namedWho: function (n) {
                return "Variable " + n;
            }
        };
    };
    if (v instanceof Lunarbox_Data_Editor_Location.FixpointOperator) {
        return {
            nth: Data_Maybe.Nothing.value,
            who: "Recursive function " + Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v.value0),
            namedWho: function (n) {
                return "Recrusive function " + n;
            }
        };
    };
    if (v instanceof Lunarbox_Data_Editor_Location.AtFunction) {
        return {
            nth: Data_Maybe.Nothing.value,
            who: "Function " + Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v.value0),
            namedWho: function (n) {
                return "Function " + n;
            }
        };
    };
    if (v instanceof Lunarbox_Data_Editor_Location.AtFunctionDeclaration) {
        return locationLEF(new Lunarbox_Data_Editor_Location.AtFunction(v.value0));
    };
    if (v instanceof Lunarbox_Data_Editor_Location.InsideFunction && v.value1 instanceof Lunarbox_Data_Editor_Node_PinLocation.PlaceholderPosition) {
        return locationLEF(new Lunarbox_Data_Editor_Location.AtFunction(v.value0));
    };
    if (v instanceof Lunarbox_Data_Editor_Location.InsideFunction) {
        var deepLocationLEF = function (v1) {
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.NodeLocation) {
                return {
                    nth: Data_Maybe.Nothing.value,
                    who: "Node " + Data_Show.show(Lunarbox_Data_Editor_Node_NodeId.showNodeId)(v1.value0),
                    namedWho: function (n) {
                        return "Node " + n;
                    }
                };
            };
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.PinLocation && v1.value1 instanceof Lunarbox_Data_Editor_Node_PinLocation.InputPin) {
                var v2 = deepLocationLEF(new Lunarbox_Data_Editor_Node_PinLocation.NodeLocation(v1.value0));
                return {
                    nth: new Data_Maybe.Just(v1.value1.value0),
                    namedWho: v2.namedWho,
                    who: v2.who
                };
            };
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.FunctionUsage) {
                return {
                    nth: Data_Maybe.Nothing.value,
                    who: "A " + (Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v1.value1) + " node"),
                    namedWho: function (n) {
                        return "Node " + (n + (" using function " + Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(v1.value1)));
                    }
                };
            };
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.InsideNative) {
                return {
                    nth: Data_Maybe.Nothing.value,
                    who: "A native function",
                    namedWho: function (n) {
                        return "Function " + Data_Show.show(Data_Show.showString)(n);
                    }
                };
            };
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.PinLocation && v1.value1 instanceof Lunarbox_Data_Editor_Node_PinLocation.OutputPin) {
                return deepLocationLEF(new Lunarbox_Data_Editor_Node_PinLocation.NodeLocation(v1.value0));
            };
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.NodeDefinition) {
                return deepLocationLEF(new Lunarbox_Data_Editor_Node_PinLocation.NodeLocation(v1.value0));
            };
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.AtApplication) {
                return deepLocationLEF(new Lunarbox_Data_Editor_Node_PinLocation.PinLocation(v1.value0, new Lunarbox_Data_Editor_Node_PinLocation.InputPin(v1.value1)));
            };
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.FunctionDeclaration) {
                return locationLEF(Lunarbox_Data_Editor_Location.UnknownLocation.value);
            };
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.UnexistingNode) {
                return locationLEF(Lunarbox_Data_Editor_Location.UnknownLocation.value);
            };
            if (v1 instanceof Lunarbox_Data_Editor_Node_PinLocation.PlaceholderPosition) {
                return locationLEF(Lunarbox_Data_Editor_Location.UnknownLocation.value);
            };
            throw new Error("Failed pattern match at Lunarbox.Component.Editor.Problems (line 135, column 3 - line 139, column 6): " + [ v1.constructor.name ]);
        };
        return deepLocationLEF(v.value1);
    };
    throw new Error("Failed pattern match at Lunarbox.Component.Editor.Problems (line 110, column 1 - line 110, column 44): " + [ v.constructor.name ]);
};
var errorIcon = Lunarbox_Component_Icon.icon("error");
var createProblemMaker = function (navigateTo) {
    return function (v) {
        return Lunarbox_Component_Utils.whenElem(Data_Eq.notEq(Lunarbox_Data_Editor_Location.eqLocation)(v.location)(Lunarbox_Data_Editor_Location.UnknownLocation.value))(function (v1) {
            return Halogen_HTML_Elements.section([ Lunarbox_Component_Utils.className("problems__card " + (function () {
                if (v.level instanceof Warning) {
                    return "problems__card--warning";
                };
                if (v.level instanceof $$Error) {
                    return "problems__card--error";
                };
                throw new Error("Failed pattern match at Lunarbox.Component.Editor.Problems (line 88, column 14 - line 90, column 47): " + [ v.level.constructor.name ]);
            })()) ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("problems__card-header") ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("problems__card-icon") ])([ (function () {
                if (v.level instanceof Warning) {
                    return warningIcon;
                };
                if (v.level instanceof $$Error) {
                    return errorIcon;
                };
                throw new Error("Failed pattern match at Lunarbox.Component.Editor.Problems (line 94, column 17 - line 96, column 37): " + [ v.level.constructor.name ]);
            })() ]), Halogen_HTML_Elements.button([ Lunarbox_Component_Utils.className("problems__card-location"), Halogen_HTML_Events.onClick(Data_Function["const"](Data_Maybe.Just.create(navigateTo(v.location)))) ])([ Halogen_HTML_Core.text(Data_Show.show(Lunarbox_Data_Editor_Location.showLocation)(v.location)) ]) ]), Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("problems__card-message") ])([ Halogen_HTML_Core.text(v.message) ]) ]);
        });
    };
};
var problems = function (v) {
    if (v.typeErrors.length === 0 && v.lintingErrors.length === 0) {
        return Halogen_HTML_Elements.main([ Lunarbox_Component_Utils.className("problems__empty") ])([ Halogen_HTML_Core.text("No errors here!") ]);
    };
    var mkProblem = createProblemMaker(v.navigateTo);
    var typeErrorHtml = Data_Functor.map(Data_Functor.functorArray)(function (error) {
        return mkProblem({
            level: $$Error.value,
            message: Lunarbox_Data_Dataflow_TypeError.printError(error),
            location: Lunarbox_Data_Dataflow_TypeError.getLocation(error)
        });
    })(v.typeErrors);
    var makeLintingErrorHtml = function (error) {
        var location = Lunarbox_Data_Dataflow_Expression_Lint.getLocation(error);
        return Lunarbox_Component_Utils.whenElem(shouldRender(v.isInternal)(location))(function (v1) {
            return mkProblem({
                level: Warning.value,
                message: Lunarbox_Data_Dataflow_Expression_Lint.printError(locationLEF(location))(error),
                location: location
            });
        });
    };
    var lintingErrorHtml = Data_Functor.map(Data_Functor.functorArray)(makeLintingErrorHtml)(v.lintingErrors);
    return Halogen_HTML_Elements.main([ Lunarbox_Component_Utils.className("problems__container") ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)(typeErrorHtml)(lintingErrorHtml));
};
module.exports = {
    errorIcon: errorIcon,
    warningIcon: warningIcon,
    problems: problems,
    shouldRender: shouldRender,
    Warning: Warning,
    "Error": $$Error,
    createProblemMaker: createProblemMaker,
    locationLEF: locationLEF
};
